// Same pattern as Ruby URI::MailTo::EMAIL_REGEXP (anchors ^ $ instead of \A \z)
const CONTACT_EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const FIELD_MAP = {
  author: { input: 'your-name', error: '.name-error' },
  email: { input: 'your-email', error: '.email-error' },
  phone: { input: 'your-phone', error: '.phone-error' },
  title: { input: 'your-subject', error: '.title-error' },
  message: { input: 'your-message', error: '.message-error' }
};

function validPhone(value) {
  const s = (value || '').trim();
  return /^\d{8,15}$/.test(s);
}

function clearFieldErrors(form) {
  Object.keys(FIELD_MAP).forEach(function (key) {
    const sel = 'input[name="' + FIELD_MAP[key].input + '"], textarea[name="' + FIELD_MAP[key].input + '"]';
    const el = form.querySelector(sel);
    if (el) el.classList.remove('error');
    const err = form.querySelector(FIELD_MAP[key].error);
    if (err) err.textContent = '';
  });
}

function setFieldError(form, modelKey, message) {
  const map = FIELD_MAP[modelKey];
  if (!map) return;
  const sel = 'input[name="' + map.input + '"], textarea[name="' + map.input + '"]';
  const el = form.querySelector(sel);
  if (el) el.classList.add('error');
  const err = form.querySelector(map.error);
  if (err) err.textContent = message;
}

function handleContactFormSubmit(e) {
  const contactForm = e.target;
  if (!contactForm.matches || !contactForm.matches('form[aria-label="Contact form"]')) return;

  e.preventDefault();

  const submitButton = contactForm.querySelector('#submit-contact');
  const spinner = contactForm.querySelector('.wpcf7-spinner');
  const successEl = contactForm.querySelector('span.contact-success');

  clearFieldErrors(contactForm);

  const author = (contactForm.querySelector('input[name="your-name"]') || {}).value || '';
  const email = (contactForm.querySelector('input[name="your-email"]') || {}).value || '';
  const phone = (contactForm.querySelector('input[name="your-phone"]') || {}).value || '';
  const title = (contactForm.querySelector('input[name="your-subject"]') || {}).value || '';
  const message = (contactForm.querySelector('textarea[name="your-message"]') || {}).value || '';

  const msg = {
    invalidEmail: contactForm.getAttribute('data-msg-invalid-email') || 'Invalid email.',
    invalidPhone: contactForm.getAttribute('data-msg-invalid-phone') || 'Invalid phone.',
    requiredAuthor:
      contactForm.getAttribute('data-msg-required-author') || 'Please enter your name.',
    requiredEmail:
      contactForm.getAttribute('data-msg-required-email') || 'Please enter your email.',
    requiredPhone:
      contactForm.getAttribute('data-msg-required-phone') || 'Please enter your phone number.',
    requiredMessage:
      contactForm.getAttribute('data-msg-required-message') || 'Please enter your message.'
  };

  let ok = true;
  if (!author.trim()) {
    setFieldError(contactForm, 'author', msg.requiredAuthor);
    ok = false;
  }
  if (!email.trim()) {
    setFieldError(contactForm, 'email', msg.requiredEmail);
    ok = false;
  } else if (!CONTACT_EMAIL_REGEXP.test(email.trim())) {
    setFieldError(contactForm, 'email', msg.invalidEmail);
    ok = false;
  }
  if (!phone.trim()) {
    setFieldError(contactForm, 'phone', msg.requiredPhone);
    ok = false;
  } else if (!validPhone(phone)) {
    setFieldError(contactForm, 'phone', msg.invalidPhone);
    ok = false;
  }
  if (!message.trim()) {
    setFieldError(contactForm, 'message', msg.requiredMessage);
    ok = false;
  }
  if (!ok) return;

  const payload = {
    author: author.trim(),
    email: email.trim(),
    phone: phone.trim(),
    message: message.trim()
  };
  const titleTrimmed = title.trim();
  if (titleTrimmed) payload.title = titleTrimmed;

  if (submitButton) submitButton.disabled = true;
  if (spinner) spinner.style.display = 'inline-block';
  contactForm.setAttribute('data-status', 'submitting');
  if (successEl) {
    successEl.textContent = '';
    successEl.classList.remove('wpcf7-mail-sent-ok');
  }

  fetch('/contacts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      const data = result.data;
      if (result.ok && data.success) {
        contactForm.reset();
        contactForm.setAttribute('data-status', 'sent');
        if (successEl) {
          successEl.textContent = data.message || '';
          successEl.classList.add('wpcf7-mail-sent-ok');
        }
      } else {
        contactForm.setAttribute('data-status', 'failed');
        const errors = data.errors || {};
        Object.keys(errors).forEach(function (field) {
          const arr = errors[field];
          const text = Array.isArray(arr) ? arr[0] : arr;
          setFieldError(contactForm, field, text);
        });
      }
    })
    .catch(function () {
      contactForm.setAttribute('data-status', 'failed');
    })
    .finally(function () {
      if (submitButton) submitButton.disabled = false;
      if (spinner) spinner.style.display = 'none';
    });
}

function bindContactFormDelegation() {
  if (document.body.dataset.contactFormDelegation === '1') return;
  document.body.dataset.contactFormDelegation = '1';
  document.addEventListener('submit', handleContactFormSubmit);
}

document.addEventListener('turbolinks:load', bindContactFormDelegation);
document.addEventListener('DOMContentLoaded', bindContactFormDelegation);
